export const GET_PRICING_PLAN = "GET_PRICING_PLAN";
export const ADD_PRICING_PLAN = "ADD_PRICING_PLAN";
export const EDIT_PRICING_PLAN = "EDIT_PRICING_PLAN";
export const DELETE_PRICING_PLAN = "DELETE_PRICING_PLAN";

export const GET_TESTMONIAL = "GET_TESTMONIAL";
export const ADD_TESTMONIAL = "ADD_TESTMONIAL";
export const EDIT_TESTMONIAL = "EDIT_TESTMONIAL";
export const DELETE_TESTMONIAL = "DELETE_TESTMONIAL";

export const GET_BUSINESS_CATEGORY = "GET_BUSINESS_CATEGORY";
export const ADD_BUSINESS_CATEGORY = "ADD_BUSINESS_CATEGORY";
export const EDIT_BUSINESS_CATEGORY = "EDIT_BUSINESS_CATEGORY";
export const DELETE_BUSINESS_CATEGORY = "DELETE_BUSINESS_CATEGORY";

export const GET_SERVICE_TAGS = "GET_SERVICE_TAGS";
export const ADD_SERVICE_TAGS = "ADD_SERVICE_TAGS";
export const EDIT_SERVICE_TAGS = "EDIT_SERVICE_TAGS";
export const DELETE_SERVICE_TAGS = "DELETE_SERVICE_TAGS";

export const City = [
  { value: "Sialkot", label: "Sialkot" },
  { value: "Lahore", label: "Lahore" },
  { value: "Karachi", label: "Karachi" },
];
export const State = [
  { value: "Punjab", label: "Punjab" },
  { value: "Sindh", label: "Sindh" },
  { value: "Sarhad", label: "Sarhad" },
];
export const PACKAGE = {
  FREE: "FREE",
};
